<script>
import { Base64 } from 'js-base64';
import {AxiosHelper} from '@src/utils/utils';

export default {
	components: {  },
	props : {
		data : {
			type : Array,
			required : true
		}
	},
  data() {
    return {
			shareName : ''

    }
	},
	created() {
	},
	mounted() {
	},
	methods : {
		show() {
			this.$refs.modal.show();	
		},

		share() {
			if(this.shareName === '') {
				alert('저장할 공유 목록의 설명을 입력해라');
				return;
			}

			AxiosHelper.post(`/api/music/share`, {
				share_name : this.shareName,
				list : Base64.encode(encodeURIComponent(JSON.stringify(this.data))),
			}).then(ret => {
				const url = window.location.origin + "/music/share/" + ret.data.$share_id;
				prompt("아래 주소로 공유됩니다.", url);
			});
		},



	}
}
</script>

<template>
	<C.Modal ref="modal" title='외부 공유'
		dialog-class-name="modal-dialog-scrollable modal-md"
	>
		<template v-slot:buttons>
			<button type="button" class="btn btn-primary"
				@click="share">공유하기</button>,
		</template>

		<div class="form-group row">
			<label class="col-4 col-form-label">외부공유 설명
				</label>
			<div class="col-7">
				<input v-model="shareName" type="text" class="form-control"/>
			</div>
		</div>
	</C.Modal>
</template>